import React from "react";
import { ParagraphSkeleton } from "@features/skeletons/common/ParagraphSkeleton/ParagraphSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const MessageSkeleton: React.FC = () => {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-row items-center justify-between border-b border-[#DEDEDE] px-4 py-5">
        <div className="flex flex-col gap-1">
          <Skeleton className="w-36 text-lg" />
          <Skeleton className="w-20 text-xs" />
        </div>
        <Skeleton variant="rounded" className="size-10" />
      </div>
      <div className="py-5 md:flex-1 md:overflow-auto">
        <div className="h-full overflow-y-auto px-4">
          <ParagraphSkeleton count={3} />
        </div>
      </div>
    </div>
  );
};
